// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"90cc42fe","513":"ab02a902","787":"2ac6aa76"}[chunkId] + ".chunk.js";
};